import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_FORM_FULL_SUNRISE_EXPERIMENT = defineFcm('promote_form_full_sunrise_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
